import { ColorCode } from '../../../constants/ui.js';
import { TextTags } from '../../types.js';
import Text, { Type } from '../../Text/Text.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import Icon from '../../Icon/Icon.js';
import { E as ExclamationCircleFilled24, C as CheckCircleFilled24 } from '../../../shared/ExclamationCircleFilled24-6db48bf7.js';
import _objectSpread from '@babel/runtime-corejs3/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import * as React from 'react';

var _excluded$1 = ["title", "titleId"];
var CheckCircle24 = function CheckCircle24(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$1);
  return /* @__PURE__ */React.createElement("svg", _objectSpread({
    fill: "none",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    "aria-labelledby": titleId
  }, props), title ? /* @__PURE__ */React.createElement("title", {
    id: titleId
  }, title) : null, /* @__PURE__ */React.createElement("path", {
    fill: "currentColor",
    d: "M16.576 9.48a.75.75 0 1 0-1.152-.96L11 13.829l-2.424-2.91a.75.75 0 1 0-1.152.961l3 3.6a.75.75 0 0 0 1.152 0z"
  }), /* @__PURE__ */React.createElement("path", {
    fill: "currentColor",
    d: "M12 1C5.924 1 1 5.926 1 12c0 6.075 4.924 11 11 11 6.074 0 11-4.925 11-11 0-6.074-4.926-11-11-11M2.5 12a9.5 9.5 0 1 1 9.5 9.5A9.5 9.5 0 0 1 2.5 12"
  }));
};
CheckCircle24.Size = 24;
CheckCircle24.Title = "CheckCircle";

var _excluded = ["title", "titleId"];
var ExclamationPoint24 = function ExclamationPoint24(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /* @__PURE__ */React.createElement("svg", _objectSpread({
    fill: "none",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    "aria-labelledby": titleId
  }, props), title ? /* @__PURE__ */React.createElement("title", {
    id: titleId
  }, title) : null, /* @__PURE__ */React.createElement("path", {
    fill: "currentColor",
    d: "M12.025 6.126c-.41 0-.75.34-.75.75v5.5c0 .41.34.75.75.75s.75-.34.75-.75v-5.5c0-.41-.34-.75-.75-.75m1 10a1 1 0 1 0-2 0 1 1 0 0 0 2 0"
  }), /* @__PURE__ */React.createElement("path", {
    fill: "currentColor",
    d: "M23 12c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11m-1.5 0a9.5 9.5 0 1 0-19 0 9.5 9.5 0 0 0 19 0"
  }));
};
ExclamationPoint24.Size = 24;
ExclamationPoint24.Title = "ExclamationPoint";

var renderIcon = function renderIcon(_ref) {
  var progressionState = _ref.progressionState,
    active = _ref.active,
    size = _ref.size,
    iconClass = _ref.iconClass;
  var iconName;
  var iconColor;
  switch (progressionState) {
    case 'completed':
      iconName = active ? CheckCircleFilled24 : CheckCircle24;
      iconColor = ColorCode.Primary;
      break;
    case 'error':
      iconName = active ? ExclamationCircleFilled24 : ExclamationPoint24;
      iconColor = ColorCode.Warning;
      break;
    default:
      return null;
  }
  return size === 'Default' ? /*#__PURE__*/jsx("span", {
    className: iconClass,
    children: /*#__PURE__*/jsx(Icon, {
      name: iconName,
      color: iconColor
    })
  }) : null;
};
var renderNumber = function renderNumber(_ref2) {
  var number = _ref2.number,
    iconClass = _ref2.iconClass,
    stepNumberClass = _ref2.stepNumberClass,
    progressionState = _ref2.progressionState,
    active = _ref2.active,
    size = _ref2.size;
  if (!number) {
    return /*#__PURE__*/jsx("div", {
      className: iconClass,
      children: /*#__PURE__*/jsx("div", {
        className: stepNumberClass
      })
    });
  }
  var ActiveSVG = function ActiveSVG() {
    return /*#__PURE__*/jsxs("svg", {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      xmlns: "http://www.w3.org/2000/svg",
      children: [/*#__PURE__*/jsx("circle", {
        cx: "10",
        cy: "10",
        r: "10"
      }), /*#__PURE__*/jsx("text", {
        x: "50%",
        y: "50%",
        textAnchor: "middle",
        dominantBaseline: "middle",
        dy: ".1em",
        fill: "white",
        className: stepNumberClass,
        children: number
      })]
    });
  };
  var NonActiveSVG = function NonActiveSVG() {
    return /*#__PURE__*/jsxs("svg", {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      xmlns: "http://www.w3.org/2000/svg",
      children: [/*#__PURE__*/jsx("circle", {
        cx: "10",
        cy: "10",
        r: "9.25",
        strokeWidth: "1.5"
      }), /*#__PURE__*/jsx("text", {
        x: "50%",
        y: "50%",
        textAnchor: "middle",
        dominantBaseline: "middle",
        dy: ".1em",
        className: stepNumberClass,
        children: number
      })]
    });
  };

  // Small Completed
  var SmallCompletedSVG = function SmallCompletedSVG() {
    return /*#__PURE__*/jsxs("svg", {
      width: "10",
      height: "10",
      viewBox: "0 0 10 10",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [/*#__PURE__*/jsx("circle", {
        cx: "5",
        cy: "5",
        r: "4",
        strokeWidth: "2"
      }), /*#__PURE__*/jsx("circle", {
        cx: "5",
        cy: "5",
        r: "2"
      })]
    });
  };
  var SmallCompletedActive = function SmallCompletedActive() {
    return /*#__PURE__*/jsx("svg", {
      width: "10",
      height: "10",
      viewBox: "0 0 10 10",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /*#__PURE__*/jsx("circle", {
        cx: "5",
        cy: "5",
        r: "5"
      })
    });
  };

  // Small Current
  var SmallCurrentSVG = function SmallCurrentSVG() {
    return /*#__PURE__*/jsx("svg", {
      width: "12",
      height: "12",
      viewBox: "0 0 12 12",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /*#__PURE__*/jsx("circle", {
        cx: "6",
        cy: "6",
        r: "5",
        strokeWidth: "2"
      })
    });
  };
  var SmallCurrentActiveSVG = function SmallCurrentActiveSVG() {
    return /*#__PURE__*/jsx("svg", {
      width: "12",
      height: "12",
      viewBox: "0 0 12 12",
      xmlns: "http://www.w3.org/2000/svg",
      children: /*#__PURE__*/jsx("circle", {
        cx: "6",
        cy: "6",
        r: "6"
      })
    });
  };

  // Small Error
  var SmallErrorSVG = function SmallErrorSVG() {
    return /*#__PURE__*/jsx("svg", {
      width: "10",
      height: "10",
      viewBox: "0 0 10 10",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /*#__PURE__*/jsx("circle", {
        cx: "5",
        cy: "5",
        r: "4",
        strokeWidth: "2"
      })
    });
  };
  var SmallErrorActiveSVG = function SmallErrorActiveSVG() {
    return /*#__PURE__*/jsx("svg", {
      width: "10",
      height: "10",
      viewBox: "0 0 10 10",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /*#__PURE__*/jsx("circle", {
        cx: "5",
        cy: "5",
        r: "5"
      })
    });
  };

  // Small disabled
  var SmallDisabledSVG = function SmallDisabledSVG() {
    return /*#__PURE__*/jsx("svg", {
      width: "10",
      height: "10",
      viewBox: "0 0 10 10",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /*#__PURE__*/jsx("circle", {
        cx: "5",
        cy: "5",
        r: "4",
        strokeWidth: "2"
      })
    });
  };
  var SmallDisabledActiveSVG = function SmallDisabledActiveSVG() {
    return /*#__PURE__*/jsx("svg", {
      width: "10",
      height: "10",
      viewBox: "0 0 10 10",
      xmlns: "http://www.w3.org/2000/svg",
      children: /*#__PURE__*/jsx("circle", {
        cx: "5",
        cy: "5",
        r: "5"
      })
    });
  };
  var getIconType = function getIconType() {
    switch (size) {
      case 'Default':
        return active ? /*#__PURE__*/jsx(ActiveSVG, {}) : /*#__PURE__*/jsx(NonActiveSVG, {});
      case 'Small':
        switch (progressionState) {
          case 'current':
            return active ? /*#__PURE__*/jsx(SmallCurrentActiveSVG, {}) : /*#__PURE__*/jsx(SmallCurrentSVG, {});
          case 'completed':
            return active ? /*#__PURE__*/jsx(SmallCompletedActive, {}) : /*#__PURE__*/jsx(SmallCompletedSVG, {});
          case 'error':
            return active ? /*#__PURE__*/jsx(SmallErrorActiveSVG, {}) : /*#__PURE__*/jsx(SmallErrorSVG, {});
          default:
            return active ? /*#__PURE__*/jsx(SmallDisabledActiveSVG, {}) : /*#__PURE__*/jsx(SmallDisabledSVG, {});
        }
      default:
        return null;
    }
  };
  return /*#__PURE__*/jsx("div", {
    className: iconClass,
    children: getIconType()
  });
};
var getTitleType = function getTitleType(size, active) {
  switch (size) {
    case 'Small':
      return Type.Subtitle;
    case 'Default':
      return active ? Type.Title : Type.Body;
    default:
      return Type.Body;
  }
};
var getTitleAsProp = function getTitleAsProp(size, active) {
  switch (size) {
    case 'Small':
      return TextTags.Subtitle;
    case 'Default':
      return active ? TextTags.Title : TextTags.Body;
    default:
      return TextTags.Title;
  }
};
var renderTitle = function renderTitle(_ref3) {
  var title = _ref3.title,
    size = _ref3.size,
    active = _ref3.active,
    titleClass = _ref3.titleClass;
  if (!title) return null;
  var titleType = getTitleType(size, active);
  var asPropType = getTitleAsProp(size, active);
  return /*#__PURE__*/jsx("div", {
    className: titleClass,
    children: /*#__PURE__*/jsx(Text, {
      as: asPropType,
      type: titleType,
      children: title
    })
  });
};
var renderLine = function renderLine(orientation, progressionState, className) {
  var isVertical = orientation === 'vertical';
  var lineStyle = {
    height: isVertical ? '100%' : '2px',
    width: isVertical ? '2px' : '100%'
  };
  var svgStyle = {
    position: 'absolute',
    height: '100%',
    width: '100%',
    overflow: 'visible'
  };
  var lineDasharray = progressionState === 'current' || progressionState === 'disabled' || progressionState === 'error' ? '0, 5' : 'none';
  var lineDashOffset = orientation === 'vertical' && (progressionState === 'current' || progressionState === 'disabled' || progressionState === 'error') ? '1' : '0';
  return /*#__PURE__*/jsx("div", {
    className: className,
    style: lineStyle,
    children: /*#__PURE__*/jsx("svg", {
      width: isVertical ? '2' : '100%',
      height: isVertical ? '100%' : '2',
      style: svgStyle,
      children: /*#__PURE__*/jsx("line", {
        x1: isVertical ? '1' : '0',
        y1: isVertical ? '0' : '1',
        x2: isVertical ? '1' : '100%',
        y2: isVertical ? '100%' : '1',
        stroke: "currentColor",
        strokeWidth: "2",
        strokeDasharray: lineDasharray,
        strokeDashoffset: lineDashOffset,
        strokeLinecap: progressionState === 'completed' ? 'square' : 'round'
      })
    })
  });
};
var handleClick = function handleClick(event) {
  event.stopPropagation();
};
var handleKeydown = function handleKeydown(event) {
  if (event.key === 'Enter' || event.key === ' ') {
    event.stopPropagation();
  }
};

export { getTitleType, handleClick, handleKeydown, renderIcon, renderLine, renderNumber, renderTitle };
//# sourceMappingURL=utils.js.map
